import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Home from './components/Home'
import ProductList from './components/ProductList'
import Cart from './components/Cart'
import Admin from './components/Admin'
import Checkout from './components/Checkout'
import OrderConfirmation from './components/OrderConfirmation'
import { CartProvider } from './context/CartContext'
import Navigation from './components/Navigation'

function App() {
  return (
    <CartProvider>
      <div className="app">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<ProductList />} />
            <Route path="/products/:category" element={<ProductList />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
      </div>
    </CartProvider>
  )
}

export default App
